export function isMobileDevice(): boolean
{
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function getDisplayDebugInfo(): Record<string, unknown>
{
  return {
    userAgent: navigator.userAgent,
    mobileByUserAgent: isMobileDevice(),
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    viewportAspect: window.innerWidth / window.innerHeight,
    visualViewportWidth: window.visualViewport?.width ?? null,
    visualViewportHeight: window.visualViewport?.height ?? null,
    visualViewportScale: window.visualViewport?.scale ?? null,
    visualViewportOffsetLeft: window.visualViewport?.offsetLeft ?? null,
    visualViewportOffsetTop: window.visualViewport?.offsetTop ?? null,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    devicePixelRatio: window.devicePixelRatio,
    maxTouchPoints: navigator.maxTouchPoints,
    coarsePointer: window.matchMedia( "(pointer: coarse)" ).matches,
    hoverNone: window.matchMedia( "(hover: none)" ).matches,
  };
}
